var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "payment__instrument" },
    [
      _c(
        "div",
        { staticClass: "paysafe-container payments_form" },
        [
          _c("div", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t("Transaction.Paysafe")))
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "desc",
            domProps: { innerHTML: _vm._s(_vm.$t("Transaction.Paysafe.Desc")) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "mthds-cont" }, [
            _c("div", { staticClass: "mthds-img" }, [
              _c("img", {
                staticClass: "psimg all",
                attrs: {
                  src: _vm.mediaServer(
                    "/static/brand-img/" +
                      _vm.brandKey +
                      "/paysafe-instruments.png"
                  ),
                  alt: "paysafe-instruments"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { id: "form", "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "div",
                [
                  _c("v-text-field", {
                    staticClass: "my-3 input-amount",
                    attrs: {
                      inputmode: "decimal",
                      label: _vm.$t("Transaction.Amount"),
                      prefix: _vm.currencySymbol,
                      required: "",
                      disabled: _vm.isProcessing,
                      rules: _vm.formInputRules
                    },
                    model: {
                      value: _vm.formData.amount,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "amount", $$v)
                      },
                      expression: "formData.amount"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.depositType
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "transaction",
                              attrs: {
                                disabled:
                                  _vm.isProcessing ||
                                  !_vm.valid ||
                                  !_vm.customerCanDeposit,
                                color: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.startTransaction("R")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Transaction.Deposit")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.withdrawType
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "transaction",
                              attrs: {
                                disabled:
                                  _vm.isProcessing ||
                                  !_vm.valid ||
                                  !_vm.customerCanWithdraw,
                                color: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.startTransaction("P")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Transaction.Withdrawal")))]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "go-back",
              on: {
                click: function($event) {
                  return _vm.goToHomepage()
                }
              }
            },
            [
              _c("v-icon", [_vm._v("navigate_before")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.back))])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "PaysafeProcessingDialog",
        {
          attrs: {
            isDialogPersistent: true,
            isProcessing: _vm.isProcessing,
            isSuccess: !_vm.transactionError,
            hideResult: _vm.paymentHandleNotCreated || _vm.paymentHandleCreated,
            processingTitle: _vm.$t("Transaction.Dialog.Processing.Title"),
            processingText: _vm.$t("Transaction.Dialog.Processing.Text"),
            successTitle:
              _vm.paysafeCashSuccessTitle ||
              _vm.$t("Transaction.Dialog.Success.Title"),
            successText:
              _vm.paysafeCashSuccessText ||
              _vm.$t("Transaction.Dialog.Success.Text"),
            errorTitle: _vm.$t("Transaction.Dialog.Error.Title")
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c("div", { attrs: { slot: "text-error" }, slot: "text-error" }, [
            _vm.brandKey !== "sb"
              ? _c(
                  "p",
                  { staticClass: "generic-icon-note" },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-1", attrs: { color: "error" } },
                      [_vm._v("error")]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.transactionError))])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.brandKey === "sb"
              ? _c("div", [
                  _c("p", [_vm._v(_vm._s(_vm.transactionError))]),
                  _vm._v(" "),
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.customerServiceMessage) }
                  })
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-732e45c3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732e45c3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/Paysafe.vue
// module id = null
// module chunks = 